import axios from 'axios';

const isAuthenticated = async ({ dashboardId }: { dashboardId: string }) => {
  const config = {
    url: `/external/dash/${dashboardId}/almanac/auth_status`,
    method: 'get' as const,
  };

  const { data } = await axios.request<{ isAuthenticated: boolean }>(config);
  return data;
};

export default isAuthenticated;
